/**
 * Full-map view toggle — a PRESENTATION-only state, orthogonal to the
 * user's filter set.
 *
 * Two-state toggle, only meaningful while the user is in Decision mode
 * (lens !== "none"):
 *
 *   Inactive ("Picks for you" showing on the map):
 *     - Shortlist emphasis ON (non-pick pins fade, shortlist panel shows).
 *     - Map framed on the picks.
 *   Active ("Full map" showing):
 *     - Shortlist emphasis OFF (all pins unfade, panel notes the state).
 *     - Map recentered to the full city frame.
 *
 * Button label convention:
 *     active === false → button says "Full map"    (press → enter full-map)
 *     active === true  → button says "Picks for you" (press → return)
 *
 * The toggle does NOT mutate the user's filters. Filters persist across
 * the toggle; "Picks for you" simply reveals the already-configured
 * decision view.
 */

const listeners = new Set<(on: boolean) => void>();
let active = false;

export function getFullMapView(): boolean {
  return active;
}

export function setFullMapView(on: boolean): void {
  if (on === active) return;
  active = on;
  for (const fn of Array.from(listeners)) {
    try {
      fn(on);
    } catch {
      /* a broken subscriber must not break the rest */
    }
  }
}

export function toggleFullMapView(): boolean {
  setFullMapView(!active);
  return active;
}

export function subscribeFullMapView(
  fn: (on: boolean) => void
): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
